import { EXPERIMENTS } from '@src/experiments'
import useExperimentBucket from '@src/quince-site-common/src/hooks/useExperimentBucket'
import { useTranslation } from 'next-i18next'

import useProductPageContext from '../../../hooks/useProductContext'

import styles from './showSimilarLabel.module.scss'

const MTE_ID = '__More_To_Explore_ID'

interface ShowSimilarPropType {
  showIfAvailable?: boolean
}

const ShowSimilarLabel = ({ showIfAvailable = false }: ShowSimilarPropType) => {
  const showSimilarExpBucket = useExperimentBucket(EXPERIMENTS.SHOW_SIMILAR_EXP.experimentName)
  const { hasMoreToExplore } = useProductPageContext()
  const { t } = useTranslation('pdp')

  function handleClick() {
    const elem = document.getElementById(MTE_ID)
    elem?.scrollIntoView({ behavior: 'smooth' })
  }

  const expNotActive = showSimilarExpBucket === EXPERIMENTS.SHOW_SIMILAR_EXP.bucketNames.control

  if (expNotActive || !showIfAvailable || !hasMoreToExplore) return null

  return (
    <div className={styles.wrapper}>
      <button className={styles.showSimilarBtn} onClick={handleClick}>
        {t('shop_similar')}
      </button>
    </div>
  )
}

export default ShowSimilarLabel
